export const miwChartColors = ["#74d4ff", "#0092b8"]; // [tailwind sky 300, tailwind cyan 600]
export const utahChartColors = ["#A0C98B", "#476c29"];

export const formatNumberOneDecimal = (value: number | undefined | null) =>
	value != null ? value.toFixed(1) : "-";

export const formatNumber = (value: number | undefined | null) => (value != null ? value : "-");

export const tooltipMark = (color: string) =>
	`<span style="background-color:${color}; display: inline-block; margin: 0px 5px 2px 0px; height: 6px; width: 6px; border-radius: 50%;"></span>`;
